import type {
	FormsTranslations,
	MarketTranslations,
	MutationTranslations,
	SharedTranslations,
	ValidationMessages,
} from "Infrastructure/Translation/Types/market";

export const mutationTranslations: MutationTranslations = {
	createMarketError: "Error creating the market.",
	createMarketSuccess: "Market was created successfully.",
	createRegionsError: "Error creating regions.",
	createRegionsSuccess: "Regions were created successfully.",
	updateMarketError: "Error updating the market.",
	updateMarketSuccess: "Market was updated successfully.",
	updateRegionError: "An error occurred while updating the region.",
	updateRegionSuccess: "The region has been updated successfully.",
	deleteRegionError: "An error occurred while deleting the region.",
	deleteRegionSuccess: "The region has been deleted successfully.",
};

export const formsTranslations: FormsTranslations = {
	labels: {
		name: "Name",
		country: "Country",
		currency: "Currency",
		iconPath: "Icon path",
		imagePath: "Image path",
		webReferrer: "Website",
		urlPath: "URL path",
		company: "Company",
		companyBankDetail: "Bank details",
		regionCode: "Region Code",
		timezone: "Timezone",
	},
	region: {
		name: "Region",
		remove: "Remove",
		addNew: "Add new",
		edit: "Edit region",
		deleteConfirmTitle: "Delete region",
		deleteConfirmMessage:
			"Are you sure you want to delete this region? This action cannot be undone.",
	},
	steps: {
		general: "General",
		regions: "Regions",
		emails: "Emails",
	},
	save: "Save",
	next: "Next",
	previous: "Previous",
	finish: "Finish",
	add: "Add",
	editMarket: "Edit market",
	createMarket: "Create market",
	skip: "Skip",
	cancel: "Cancel",
};

export const sharedTranslations: SharedTranslations = {
	title: "Markets",
	description: "Add new market or edit the existing markets",
	card: {
		marketHeading: "Manage Markets",
		marketSubheading:
			"Choose a market from the list to edit or add a new market.",
	},
	select: {
		hello: "Hello",
		selectMarket: "Please select market",
	},
};

export const validationMessagesTranslations: ValidationMessages = {
	regionName: "Region name is required",
	regionCode: "Region code is required",
	webReferrer: "Website is required",
	name: "Name is required",
	urlPath: "URL path is required",
};

export const marketTranslations: MarketTranslations = {
	forms: formsTranslations,
	mutations: mutationTranslations,
	shared: sharedTranslations,
	validationMessages: validationMessagesTranslations,
};
